import styled from 'styled-components';

export const HeaderContainer = styled('header')`
  margin-top: auto;
  padding-top: 30px;
  padding-bottom: 20px;
  background-color: #666666;
  margin-bottom: 20px;
`;

export const AppName = styled('h1')`
  color: #ffffff;
  text-align: center;
`;

export const LogoContainer = styled('div')`
  max-width: 200px;
  width: 100%;
  margin: auto;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 120px;
    width: auto;
    height: auto;
  }
`;

export const Title = styled('h2')`
  color: #ffffff;
  font-weight: bold;
  font-size: 28px;
`;
